<script setup lang="ts">
import DropdownMenuItemContent from "~/components/dumb/DropdownMenuItemContent.vue";
import Template from "~/components/dumb/Template.vue";
import Tooltip from "~/components/dumb/Tooltip.vue";
import { Placement } from "~/shared/enums";
import type { ProcessedMenuItem } from "~/shared/types";
import { usePageStore } from "~/stores";

const props = defineProps<{
  item: ProcessedMenuItem;
}>();

const emit = defineEmits<{
  click: [event: Event];
}>();

const pageStore = usePageStore();

const onClick = (event: Event) => {
  if (!props.item.disabled && !props.item.noFocus) {
    emit("click", event);
  }
};
</script>

<template>
  <component
    :is="item.tooltipText || (item.disabled && item.disabledReason) ? Tooltip : Template"
    :placement="Placement.LEFT"
    :text="item.disabledReason ?? item.tooltipText"
    disable-click-hide
    block
    :show-delay="200">
    <div v-if="item.disabled && !pageStore.isMobile" class="absolute inset-0" />
    <component
      :is="item.component"
      v-bind="item.args"
      :class="{
        'pointer-events-none text-vlt': item.disabled,
        'text-md': !item.disabled,
        'cursor-pointer': !item.disabled && !item.noFocus,
        'text-base': pageStore.isMobile,
        'text-sm': !pageStore.isMobile,
      }"
      class="flex w-full select-none"
      @click="onClick">
      <DropdownMenuItemContent
        :title="item.title"
        :icon="item.icon"
        :icon-args="item.iconArgs"
        :icon-after="item.iconAfter"
        :icon-after-args="item.iconAfterArgs"
        :show-icon-after-on-hover="item.showIconAfterOnHover"
        :selected="item.selected"
        :disabled="item.disabled"
        :subtitle="item.subtitle"
        :strikethrough="item.strikethrough"
        :command-id="item.commandId"
        :data-testid="item.dataTestid" />
    </component>
  </component>
</template>
